import { render, staticRenderFns } from "./SearchProductPreloader.vue?vue&type=template&id=46135cf6&scoped=true&"
import script from "./SearchProductPreloader.vue?vue&type=script&lang=ts&"
export * from "./SearchProductPreloader.vue?vue&type=script&lang=ts&"
import style0 from "./SearchProductPreloader.vue?vue&type=style&index=0&id=46135cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46135cf6",
  null
  
)

export default component.exports